import React from "react";
import MuiLoadingButton from "@mui/lab/LoadingButton";

const LoadingButton = ({
  float = "right",
  fullWidthMobile = false,
  loading = false,
  disabled = loading,
  backgroundColor = sessionStorage.getItem("buttonBackground") ||
    "rgba(57, 54, 239, 1)",
  ...props
}) => (
  <MuiLoadingButton
    {...props}
    variant="contained"
    color="primary"
    sx={{
      fontSize: "16px",
      float: float,
      fontWeight: 600,
      fontStyle: "normal",
      borderRadius: "8px",
      backgroundColor: loading ? backgroundColor : backgroundColor,
      color: sessionStorage.getItem("buttonColor") || "#FFF",
      width: "100%",
      "@media (min-width: 1000px)": {
        width: "100%",
      },
      "@media (max-width: 420px)": {
        fontSize: "12px !important",
        padding: "8px !important",
      },
      "&:hover": {
        backgroundColor: loading ? backgroundColor : backgroundColor,
        borderRadius: "8px",
      },
    }}
    disabled={disabled}
    loading={loading}
  >
    {props.children}
  </MuiLoadingButton>
);

export default LoadingButton;
